import type { RatingT } from '@mentimeter/question-modules-types';
import type { RatingStaticContent } from '@core-api/presentation/types/response';
import { useFlag } from '@mentimeter/flags/confidence/client';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { RatingPresentation } from './RatingPresentation';

export function RatingPresentationDataHandler() {
  const { useQuestion, InteractiveCanvasComponents, useConfig, useResults } =
    usePresentationContext();
  const { enableAnimations } = useConfig();

  const results = useResults<RatingT>();

  const slide = useQuestion();

  const { value: isNewLookFlagEnabled } = useFlag(
    'sli-new-look-rating.enabled',
    false,
  );

  const staticContent = slide.staticContent as RatingStaticContent;

  const range = {
    min: slide.interactiveContents[0]!.responseRange?.min ?? 0,
    max: slide.interactiveContents[0]!.responseRange?.max ?? 10,
  };

  return (
    <RatingPresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      longerDescription={slide.interactiveContents[0]!.description}
      fontSizeOffset={staticContent.textSizeOffset}
      shouldHideResults={slide.responseVisibility === 'hidden'}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
      choices={slide.interactiveContents[0]!.choices.map((choice, index) => ({
        id: choice.legacyChoiceId ?? index,
        label: choice.title,
      }))}
      isNewLookFlagEnabled={isNewLookFlagEnabled}
      shouldAnimate={enableAnimations}
      results={results}
      visualizationType={staticContent.interactiveContentStyling.visualization}
      xAxisLabels={staticContent.interactiveContentStyling.xAxisLabels}
      yAxisLabels={staticContent.interactiveContentStyling.yAxisLabels}
      range={range}
      grid={slide.grid}
    />
  );
}
